<template>
  <q-dialog v-model="dialogAberto" maximized persistent>
    <q-card class="column no-wrap" style="min-height: 100vh">
      <!-- Header -->
      <q-bar style="background-color: #21324a; color: white; flex-shrink: 0">
        <q-icon name="school" />
        <span class="text-weight-bold q-ml-sm">
          {{
            modoEditar
              ? `Editar Treinamento — ${registroEditar?.userName || ""}`
              : "Novo Treinamento"
          }}
        </span>
        <q-space />
        <q-btn dense flat icon="close" color="white" @click="fechar" />
      </q-bar>

      <!-- Corpo com scroll -->
      <q-card-section class="col overflow-auto q-pa-md">
        <div class="q-gutter-md">
          <!-- Dados da Sessão -->
          <q-card flat bordered class="q-pa-md">
            <p class="text-subtitle1 text-weight-bold text-brand-1 q-mb-md">
              Dados da Sessão
            </p>
            <div class="row wrap q-gutter-sm">
              <div>
                <div class="texto-titulo-input">Data do Treinamento *</div>
                <q-input
                  class="input-new-design"
                  style="width: 200px"
                  dense
                  outlined
                  mask="##/##/####"
                  v-model="dataTreinamento"
                  placeholder="dd/mm/aaaa"
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        cover
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          :locale="myLocale"
                          mask="DD/MM/YYYY"
                          v-model="dataTreinamento"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Fechar"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>

              <div>
                <div class="texto-titulo-input">Tenant *</div>
                <q-input
                  class="input-new-design"
                  style="width: 200px"
                  dense
                  outlined
                  v-model="tenantForm"
                  maxlength="100"
                />
              </div>

              <div>
                <div class="texto-titulo-input">Nome do Instrutor *</div>
                <q-input
                  class="input-new-design"
                  style="width: 260px"
                  dense
                  outlined
                  v-model="instrutorNome"
                  maxlength="200"
                />
              </div>

              <div>
                <div class="texto-titulo-input">E-mail do Instrutor *</div>
                <q-input
                  class="input-new-design"
                  style="width: 300px"
                  dense
                  outlined
                  v-model="instrutorEmail"
                  maxlength="200"
                />
              </div>
            </div>
          </q-card>

          <!-- Participantes -->
          <q-card flat bordered class="q-pa-md">
            <div class="row items-center q-mb-md">
              <p class="text-subtitle1 text-weight-bold text-brand-1 q-mb-none">
                Participantes
              </p>
              <q-space />
              <q-btn
                v-if="!processando"
                flat
                dense
                no-caps
                icon="person_add"
                label="Adicionar participante"
                color="primary"
                @click="adicionarParticipante"
              />
            </div>

            <div v-for="(p, idx) in participantes" :key="idx" class="q-mb-sm">
              <q-card flat bordered class="q-pa-sm bg-grey-1">
                <div class="row items-start wrap q-gutter-sm">
                  <div
                    class="text-subtitle2 text-grey-6 self-center"
                    style="min-width: 24px"
                  >
                    #{{ idx + 1 }}
                  </div>

                  <!-- Nome -->
                  <div>
                    <div class="texto-titulo-input">Nome *</div>
                    <q-input
                      class="input-new-design"
                      style="width: 230px"
                      dense
                      outlined
                      v-model="p.nome"
                      maxlength="200"
                      :disable="processando || p.submitStatus === 'sucesso'"
                    />
                  </div>

                  <!-- E-mail -->
                  <div>
                    <div class="texto-titulo-input">E-mail *</div>
                    <q-input
                      class="input-new-design"
                      style="width: 240px"
                      dense
                      outlined
                      v-model="p.email"
                      maxlength="200"
                      :disable="processando || p.submitStatus === 'sucesso'"
                    />
                  </div>

                  <!-- SAP -->
                  <div>
                    <div class="texto-titulo-input">SAP (Matrícula) *</div>
                    <q-input
                      class="input-new-design"
                      style="width: 160px"
                      dense
                      outlined
                      v-model="p.sap"
                      maxlength="100"
                      :disable="processando || p.submitStatus === 'sucesso'"
                      @blur="buscarParticipante(idx)"
                    >
                      <template v-slot:append>
                        <q-spinner-dots
                          v-if="p.lookupStatus === 'buscando'"
                          size="xs"
                          color="primary"
                        />
                      </template>
                    </q-input>
                  </div>

                  <!-- Celular -->
                  <div>
                    <div class="texto-titulo-input">Celular</div>
                    <q-input
                      class="input-new-design"
                      style="width: 200px"
                      dense
                      outlined
                      v-model="p.celular"
                      mask="(##) #####-####"
                      fill-mask
                      unmasked-value
                      placeholder="(11) 99999-9999"
                      :disable="processando || p.submitStatus === 'sucesso'"
                    />
                  </div>

                  <!-- Lookup badge -->
                  <div class="self-end q-pb-xs">
                    <q-chip
                      v-if="p.lookupStatus === 'existente'"
                      dense
                      color="positive"
                      text-color="white"
                      icon="check_circle"
                      size="sm"
                    >
                      Atualizar — {{ p.lookupNome }}
                    </q-chip>
                    <q-chip
                      v-else-if="p.lookupStatus === 'novo'"
                      dense
                      color="info"
                      text-color="white"
                      icon="person_add"
                      size="sm"
                    >
                      Novo usuário
                    </q-chip>
                  </div>

                  <q-space />

                  <!-- Status de envio -->
                  <div v-if="p.submitStatus === 'loading'" class="self-center">
                    <q-spinner-dots color="primary" size="28px" />
                  </div>
                  <div
                    v-else-if="p.submitStatus === 'sucesso'"
                    class="self-center row items-center"
                  >
                    <q-icon name="check_circle" color="positive" size="24px" />
                    <span class="text-positive text-caption q-ml-xs"
                      >Registrado</span
                    >
                  </div>
                  <div
                    v-else-if="p.submitStatus === 'erro'"
                    class="self-center column items-start"
                  >
                    <div class="row items-center no-wrap">
                      <q-icon name="error" color="negative" size="20px" />
                      <span class="text-negative text-caption q-ml-xs"
                        >Erro</span
                      >
                      <q-btn
                        flat
                        dense
                        no-caps
                        icon="refresh"
                        color="negative"
                        size="sm"
                        label="Reenviar"
                        class="q-ml-xs"
                        @click="reprocessar(idx)"
                      />
                    </div>
                    <div
                      class="text-caption text-negative q-mt-xs"
                      style="max-width: 240px"
                    >
                      {{ p.submitErro }}
                    </div>
                  </div>

                  <!-- Remover participante -->
                  <q-btn
                    v-if="
                      !processando &&
                      p.submitStatus !== 'sucesso' &&
                      participantes.length > 1
                    "
                    flat
                    dense
                    icon="close"
                    color="grey-5"
                    size="sm"
                    class="self-center"
                    @click="removerParticipante(idx)"
                  />
                </div>
              </q-card>
            </div>
          </q-card>

          <!-- Conteúdo Programático -->
          <q-card flat bordered>
            <div
              class="q-pa-md row items-center q-gutter-xs"
              style="border-bottom: 1px solid #e0e0e0"
            >
              <p class="text-subtitle1 text-weight-bold text-brand-1 q-mb-none">
                Conteúdo Programático
              </p>
              <q-btn
                flat
                no-caps
                dense
                size="xs"
                :label="
                  modulosForm.every((m) =>
                    m.conteudos.every((c) => c.selecionado)
                  )
                    ? 'desmarcar'
                    : 'todos'
                "
                color="primary"
                :disable="processando"
                @click="toggleSelecionarTodosGlobal"
              />
            </div>
            <div class="row no-wrap" style="min-height: 320px">
              <!-- Painel esquerdo: lista de módulos -->
              <div
                style="
                  width: 220px;
                  flex-shrink: 0;
                  border-right: 1px solid #e0e0e0;
                  overflow-y: auto;
                "
              >
                <q-list dense separator>
                  <q-item
                    v-for="(modulo, idx) in modulosForm"
                    :key="modulo.nome"
                    clickable
                    :active="moduloAtivoIdx === idx"
                    active-class="bg-blue-1 text-brand-1"
                    @click="moduloAtivoIdx = idx"
                  >
                    <q-item-section>
                      <q-item-label
                        class="text-weight-medium"
                        style="font-size: 13px"
                        >{{ modulo.nome }}</q-item-label
                      >
                    </q-item-section>
                    <q-item-section side>
                      <q-badge
                        v-if="
                          modulo.conteudos.filter((c) => c.selecionado).length +
                            (modulo.outroAtivo ? 1 : 0) >
                          0
                        "
                        color="primary"
                        rounded
                      >
                        {{
                          modulo.conteudos.filter((c) => c.selecionado).length +
                          (modulo.outroAtivo ? 1 : 0)
                        }}
                      </q-badge>
                    </q-item-section>
                  </q-item>
                </q-list>
                <!-- Botão Add Módulo -->
                <div class="q-pa-sm">
                  <q-btn
                    flat
                    no-caps
                    dense
                    icon="add"
                    label="Add Módulo"
                    color="primary"
                    size="sm"
                    class="full-width"
                    :disable="processando"
                    @click="novoModuloAberto = true"
                  />
                </div>

                <!-- Mini-form novo módulo -->
                <q-dialog v-model="novoModuloAberto" persistent>
                  <q-card style="min-width: 340px">
                    <q-bar
                      style="background-color: #21324a; color: white"
                      class="q-mb-sm"
                    >
                      <q-icon name="add_box" />
                      <span class="q-ml-sm text-weight-bold">Novo Módulo</span>
                      <q-space />
                      <q-btn
                        dense
                        flat
                        icon="close"
                        color="white"
                        @click="fecharNovoModulo"
                      />
                    </q-bar>
                    <q-card-section class="q-gutter-sm">
                      <div class="texto-titulo-input">Nome do Módulo *</div>
                      <q-input
                        v-model="novoModuloNome"
                        dense
                        outlined
                        placeholder="Ex: Relatórios"
                        autofocus
                        @keyup.enter="novoConteudoFocus"
                      />
                      <div class="texto-titulo-input q-mt-sm">
                        Conteúdos (um por linha) *
                      </div>
                      <q-input
                        ref="novoConteudoRef"
                        v-model="novoModuloConteudos"
                        dense
                        outlined
                        type="textarea"
                        rows="5"
                        placeholder="Criação de Relatório X&#10;Exportar Relatório Y&#10;..."
                      />
                      <div class="text-caption text-grey-6">
                        Todos os conteúdos serão marcados como selecionados
                        automaticamente.
                      </div>
                    </q-card-section>
                    <q-card-actions align="right">
                      <q-btn
                        flat
                        no-caps
                        label="Cancelar"
                        @click="fecharNovoModulo"
                      />
                      <q-btn
                        no-caps
                        label="Adicionar"
                        style="
                          background-color: #21324a;
                          border-radius: 8px;
                          color: white;
                        "
                        :disable="!novoModuloNome || !novoModuloConteudos"
                        @click="confirmarNovoModulo"
                      />
                    </q-card-actions>
                  </q-card>
                </q-dialog>
              </div>

              <!-- Painel direito: checkboxes do módulo ativo -->
              <div class="col q-pa-md overflow-auto">
                <div
                  v-if="modulosForm[moduloAtivoIdx]"
                  class="column q-gutter-xs"
                >
                  <div class="row items-center q-mb-sm q-gutter-xs">
                    <p
                      class="text-weight-bold text-brand-1 q-mb-none"
                      style="font-size: 14px"
                    >
                      Módulo de {{ modulosForm[moduloAtivoIdx].nome }}
                    </p>
                    <q-btn
                      flat
                      no-caps
                      dense
                      size="xs"
                      :label="
                        modulosForm[moduloAtivoIdx].conteudos.every(
                          (c) => c.selecionado
                        )
                          ? 'desmarcar'
                          : 'todos'
                      "
                      color="primary"
                      :disable="processando"
                      @click="
                        toggleSelecionarTodos(
                          moduloAtivoIdx,
                          !modulosForm[moduloAtivoIdx].conteudos.every(
                            (c) => c.selecionado
                          )
                        )
                      "
                    />
                  </div>
                  <q-checkbox
                    v-for="conteudo in modulosForm[moduloAtivoIdx].conteudos"
                    :key="conteudo.nome"
                    v-model="conteudo.selecionado"
                    :label="conteudo.nome"
                    :disable="processando"
                    dense
                  />
                  <div
                    v-if="modulosForm[moduloAtivoIdx].temOutro"
                    class="row items-center q-mt-xs"
                  >
                    <q-checkbox
                      v-model="modulosForm[moduloAtivoIdx].outroAtivo"
                      label="Outro:"
                      :disable="processando"
                      dense
                    />
                    <q-input
                      v-if="modulosForm[moduloAtivoIdx].outroAtivo"
                      v-model="modulosForm[moduloAtivoIdx].outroTexto"
                      dense
                      outlined
                      placeholder="Descreva..."
                      class="q-ml-sm"
                      style="width: 180px; font-size: 12px"
                      :disable="processando"
                    />
                  </div>
                </div>
              </div>
            </div>
          </q-card>
        </div>
      </q-card-section>

      <!-- Rodapé fixo -->
      <q-card-actions
        class="q-px-md q-py-sm row items-center"
        style="border-top: 1px solid #e0e0e0; flex-shrink: 0"
      >
        <q-btn flat no-caps label="Fechar" @click="fechar" />
        <q-btn
          v-if="!todosConcluidos"
          no-caps
          icon="send"
          :label="processando ? 'Processando...' : 'Registrar Treinamento'"
          style="background-color: #21324a; border-radius: 8px; color: white"
          :disable="!formValido || processando"
          :loading="processando"
          @click="processarTodos"
        />
        <q-space />
        <span v-if="resultadoResumo" class="text-body2">
          <q-icon
            :name="resultadoResumo.erros > 0 ? 'warning' : 'check_circle'"
            :color="resultadoResumo.erros > 0 ? 'warning' : 'positive'"
            size="18px"
          />
          <span class="q-ml-xs">
            {{ resultadoResumo.sucessos }} de
            {{ participantes.length }} registrado(s) com sucesso
          </span>
          <span v-if="resultadoResumo.erros > 0" class="text-negative q-ml-xs">
            — {{ resultadoResumo.erros }} com erro (use os botões de reenvio
            acima)
          </span>
        </span>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { treinamentoUsuariosService } from "../../../services/treinamentoUsuariosService";

const MODULOS_PADRAO = [
  {
    nome: "Requisição",
    temOutro: true,
    conteudos: [
      "Criação de Requisição",
      "Aprovação de Requisição",
      "Cancelamento e Rejeição de Requisição",
      "Edição de Quantidade",
      "Troca de Produto",
      "Restauração de Requisição",
    ],
  },
  {
    nome: "Produtos",
    temOutro: true,
    conteudos: [
      "Criação de Produto Manual e Adicionar ao Catálogo",
      "Criação de Produto via Template",
      "Edição de Produto",
      "Remoção do catálogo",
      "Criação de Grupos de Produtos",
      "Edição de Grupos de Produtos",
      "Criação de Regras",
      "Edição de Regras",
      "Cadastro e Edição de CAs",
      "Vínculo e Desvinculo de CAs",
    ],
  },
  {
    nome: "Usuários",
    temOutro: true,
    conteudos: [
      "Criação de Usuários Manual",
      "Criação de Usuários via Template",
      "Edição de Cadastro de Usuários",
      "Definição de Regra Individual",
      "Definição de Hierarquia",
      "Desligar e Afastar Colaborador",
      "Cadastro de Biometrias",
    ],
  },
  {
    nome: "Compras",
    temOutro: true,
    conteudos: [
      "Criação de Pedido de Compras",
      "Edição de Pedido de Compras",
      "Receber Pedido de Compras",
      "Criação de Necessidade de Compras",
      "Edição de Necessidade de Compras",
      "Cadastro e Edição de Fornecedores",
    ],
  },
  {
    nome: "Segurança",
    temOutro: true,
    conteudos: [
      "Consulta e Export do Relatório Status Troca",
      "Consulta e Export do Relatório Master Data",
      "Consulta e Export de Ficha de EPI",
      "Criação e Edição de GHEs",
      "Liberação de Prazo Mínimo",
    ],
  },
  {
    nome: "Indicadores",
    temOutro: true,
    conteudos: [
      "Consulta e Export do Relatório de Consumo",
      "Consulta e Export do Relatório de Estoque",
      "Consulta e Export do Relatório Master Data",
      "Consulta e Export do Relatório Status Troca",
    ],
  },
  {
    nome: "Picking",
    temOutro: false,
    conteudos: [
      "Criação de Picking",
      "Criação de Etapa de Transporte",
      "Confirmação de Recebimento",
      "Listagem de Pickings",
    ],
  },
  {
    nome: "Ferramentaria ADM",
    temOutro: false,
    conteudos: [
      "Criação de Empréstimo e Devolução de Ferramentas",
      "Criação e Edição de Ferramentas",
      "Configuração de Relatório de Cautela",
      "Impressão de Relatório de Cautela",
      "Vínculo de Usuários a Ferramentas",
      "Criação e Vínculo de Checklists",
      "Criação e Vínculo de Grupos e Subgrupos a Produtos",
      "Consulta de Relatórios de Ferramentaria e Export",
    ],
  },
  {
    nome: "Catálogo WF",
    temOutro: false,
    conteudos: ["Consultar WF", "Aprovar WF", "Rejeitar WF"],
  },
  {
    nome: "Tipo de máquina Balcão",
    temOutro: false,
    conteudos: [
      "Adaptação de Configurações ao Fluxo do Cliente",
      "Teste de Credencial",
      "Criação de Requisição",
      "Liberação de Requisição",
    ],
  },
];

function hojeFormatado() {
  const hoje = new Date();
  const d = String(hoje.getDate()).padStart(2, "0");
  const m = String(hoje.getMonth() + 1).padStart(2, "0");
  return `${d}/${m}/${hoje.getFullYear()}`;
}

function buildModulosState() {
  return MODULOS_PADRAO.map((mod) => ({
    nome: mod.nome,
    temOutro: mod.temOutro,
    conteudos: mod.conteudos.map((nome) => ({ nome, selecionado: false })),
    outroAtivo: false,
    outroTexto: "",
  }));
}

function novoParticipanteObj() {
  return {
    nome: "",
    email: "",
    sap: "",
    celular: "",
    lookupStatus: null, // null | 'buscando' | 'novo' | 'existente'
    lookupDocId: null,
    lookupNome: null,
    submitStatus: null, // null | 'loading' | 'sucesso' | 'erro'
    submitErro: null,
  };
}

export default {
  name: "TreinamentoSessaoForm",
  props: {
    modelValue: { type: Boolean, default: false },
    modoEditar: { type: Boolean, default: false },
    registroEditar: { type: Object, default: null },
  },
  emits: ["update:modelValue", "salvo"],
  setup(props, { emit }) {
    const store = useStore();
    const usuarioLogado = computed(
      () => store.getters["autenticacao/usuarioLogado"]
    );
    const tenantAtual = window.location.host.split(".")[0];

    const dataTreinamento = ref(hojeFormatado());
    const tenantForm = ref(tenantAtual);
    const instrutorNome = ref("");
    const instrutorEmail = ref("");
    const participantes = ref([novoParticipanteObj()]);
    const modulosForm = ref(buildModulosState());
    const processando = ref(false);

    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 0,
    };

    const dialogAberto = computed({
      get: () => props.modelValue,
      set: (val) => emit("update:modelValue", val),
    });

    const formValido = computed(() => {
      if (
        !dataTreinamento.value ||
        !tenantForm.value ||
        !instrutorNome.value ||
        !instrutorEmail.value
      )
        return false;
      if (participantes.value.length === 0) return false;
      return participantes.value.every((p) => p.nome && p.email && p.sap);
    });

    const todosConcluidos = computed(() => {
      if (participantes.value.length === 0) return false;
      return participantes.value.every(
        (p) => p.submitStatus === "sucesso" || p.submitStatus === "erro"
      );
    });

    const resultadoResumo = computed(() => {
      if (!todosConcluidos.value) return null;
      const sucessos = participantes.value.filter(
        (p) => p.submitStatus === "sucesso"
      ).length;
      const erros = participantes.value.filter(
        (p) => p.submitStatus === "erro"
      ).length;
      return { sucessos, erros };
    });

    const moduloAtivoIdx = ref(0);

    function resetarForm() {
      dataTreinamento.value = hojeFormatado();
      tenantForm.value = tenantAtual;
      instrutorNome.value = usuarioLogado.value?.nome || "";
      instrutorEmail.value = usuarioLogado.value?.email || "";
      participantes.value = [novoParticipanteObj()];
      modulosForm.value = buildModulosState();
      moduloAtivoIdx.value = 0;
      processando.value = false;
    }

    watch(
      () => props.modelValue,
      (aberto) => {
        if (aberto) {
          resetarForm();
          if (props.modoEditar && props.registroEditar) {
            tenantForm.value = props.registroEditar.tenant || tenantAtual;
            participantes.value = [
              {
                ...novoParticipanteObj(),
                nome: props.registroEditar.userName || "",
                email: props.registroEditar.userEmail || "",
                sap: props.registroEditar.userSap || "",
                celular: props.registroEditar.userPhone
                  ? String(props.registroEditar.userPhone).replace(/^55/, "")
                  : "",
                lookupStatus: "existente",
                lookupDocId: props.registroEditar.id,
                lookupNome: props.registroEditar.userName || "",
              },
            ];
          }
        }
      }
    );

    function fechar() {
      const temSucesso = participantes.value.some(
        (p) => p.submitStatus === "sucesso"
      );
      emit("update:modelValue", false);
      if (temSucesso) emit("salvo");
    }

    function adicionarParticipante() {
      participantes.value.push(novoParticipanteObj());
    }

    function removerParticipante(idx) {
      participantes.value.splice(idx, 1);
    }

    async function buscarParticipante(idx) {
      const p = participantes.value[idx];
      if (!p.sap || !tenantForm.value) return;
      p.lookupStatus = "buscando";
      try {
        const resp = await treinamentoUsuariosService.listar({
          tenant: tenantForm.value,
          userSap: p.sap,
        });
        const resultados = resp.data?.results ?? [];
        const idEsperado = `${tenantForm.value}-${p.sap}`;
        const match = resultados.find((r) => r.id === idEsperado);
        if (match) {
          p.lookupStatus = "existente";
          p.lookupDocId = match.id;
          p.lookupNome = match.userName;
          if (!p.nome) p.nome = match.userName || "";
          if (!p.email) p.email = match.userEmail || "";
        } else {
          p.lookupStatus = "novo";
          p.lookupDocId = null;
          p.lookupNome = null;
        }
      } catch {
        p.lookupStatus = null;
      }
    }

    function buildPayload(p) {
      const modulosPayload = modulosForm.value
        .map((m) => {
          const conteudos = m.conteudos
            .filter((c) => c.selecionado)
            .map((c) => ({ nome: c.nome }));
          if (m.temOutro && m.outroAtivo && m.outroTexto) {
            conteudos.push({ nome: `Outro: ${m.outroTexto}` });
          }
          return conteudos.length > 0
            ? { nome: m.nome, totalConteudos: conteudos.length, conteudos }
            : null;
        })
        .filter(Boolean);
      return {
        tenant: tenantForm.value,
        userName: p.nome,
        userEmail: p.email,
        userSap: p.sap,
        userPhone: p.celular ? `55${p.celular}` : undefined,
        dataTreinamentoWeb: dataTreinamento.value,
        tipoTreinamentoWeb: "online",
        instrutorNome: instrutorNome.value,
        instrutorEmail: instrutorEmail.value,
        alteradoPorNome: usuarioLogado.value?.nome || "",
        alteradoPorEmail: usuarioLogado.value?.email || "",
        modulosTreinamentoWeb: modulosPayload,
      };
    }

    async function processarParticipante(idx) {
      const p = participantes.value[idx];
      p.submitStatus = "loading";
      p.submitErro = null;
      const payload = buildPayload(p);
      const operacao =
        p.lookupStatus === "existente" && p.lookupDocId ? "PUT" : "POST";
      const url =
        operacao === "PUT" ? `[ENDPOINT]/${p.lookupDocId}` : "[ENDPOINT]";

      // TODO: remover logs e descomentar chamadas reais após validação do backend
      console.group(
        `[Treinamento] Participante #${idx + 1} — ${operacao} ${url}`
      );
      console.log("Payload:", JSON.parse(JSON.stringify(payload)));
      console.groupEnd();

      try {
        if (operacao === "PUT") {
          await treinamentoUsuariosService.editar(p.lookupDocId, payload);
        } else {
          await treinamentoUsuariosService.criar(payload);
        }
        p.submitStatus = "sucesso";
      } catch (err) {
        p.submitStatus = "erro";
        const status = err?.response?.status;
        const msg =
          err?.response?.data?.message || err?.message || "Erro desconhecido";
        p.submitErro = status ? `HTTP ${status}: ${msg}` : msg;
      }
    }

    async function processarTodos() {
      processando.value = true;
      for (let i = 0; i < participantes.value.length; i++) {
        if (participantes.value[i].submitStatus === "sucesso") continue;
        await processarParticipante(i);
      }
      processando.value = false;
    }

    function reprocessar(idx) {
      processarParticipante(idx);
    }

    function toggleSelecionarTodos(idx, valor) {
      modulosForm.value[idx].conteudos.forEach((c) => {
        c.selecionado = valor;
      });
    }

    function toggleSelecionarTodosGlobal() {
      const todosAtivos = modulosForm.value.every((m) =>
        m.conteudos.every((c) => c.selecionado)
      );
      modulosForm.value.forEach((m) => {
        m.conteudos.forEach((c) => {
          c.selecionado = !todosAtivos;
        });
      });
    }

    const novoModuloAberto = ref(false);
    const novoModuloNome = ref("");
    const novoModuloConteudos = ref("");
    const novoConteudoRef = ref(null);

    function novoConteudoFocus() {
      novoConteudoRef.value?.focus();
    }

    function fecharNovoModulo() {
      novoModuloAberto.value = false;
      novoModuloNome.value = "";
      novoModuloConteudos.value = "";
    }

    function confirmarNovoModulo() {
      const conteudos = novoModuloConteudos.value
        .split("\n")
        .map((l) => l.trim())
        .filter((l) => l.length > 0)
        .map((nome) => ({ nome, selecionado: true }));
      modulosForm.value.push({
        nome: novoModuloNome.value.trim(),
        temOutro: false,
        conteudos,
        outroAtivo: false,
        outroTexto: "",
      });
      moduloAtivoIdx.value = modulosForm.value.length - 1;
      fecharNovoModulo();
    }

    return {
      dialogAberto,
      dataTreinamento,
      tenantForm,
      instrutorNome,
      instrutorEmail,
      participantes,
      modulosForm,
      moduloAtivoIdx,
      processando,
      myLocale,
      formValido,
      todosConcluidos,
      resultadoResumo,
      fechar,
      adicionarParticipante,
      removerParticipante,
      buscarParticipante,
      processarTodos,
      reprocessar,
      toggleSelecionarTodos,
      toggleSelecionarTodosGlobal,
      novoModuloAberto,
      novoModuloNome,
      novoModuloConteudos,
      novoConteudoRef,
      novoConteudoFocus,
      fecharNovoModulo,
      confirmarNovoModulo,
    };
  },
};
</script>
